<template lang="" src="./Header.html"></template>


<script>
import HeaderLogo from '@/components/Header/HeaderLogo/HeaderLogo.vue';

export default {
    name: 'ModuleHeader',
    components: {
        HeaderLogo,
    }
}
</script>

<style lang="scss" src="./Header.scss"> </style>